export * from './apiPath'
export const baseUrl = import.meta.env.VITE_API_URL
export const devUrl = import.meta.env.VITE_API_URL_DEV

function getClearUrl(url: string): string {
  try {
    const parsed = new URL(url)
    return `${parsed.protocol}//${parsed.host}`
  } catch {
    return url
  }
}
export const devClearUrl = getClearUrl(import.meta.env.VITE_API_URL_DEV)

export const domain = {
  name: 'UFarm Backend',
  version: '2',
} as const
export const deadlineMinutes = 5

export const invitationLifetimeMinutes = import.meta.env.VITE_INVITATION_LIFETIME_MINUTES
  ? parseInt(import.meta.env.VITE_INVITATION_LIFETIME_MINUTES, 10)
  : 1440 // 24 hours

export const email = 'hello@ufarm.digital'

export const LANDING_PAGE = 'https://ufarm.digital/'
export const FUND_PAGE = import.meta.env.VITE_FUND_URL
export const referralKey = 'referral'
export const poolIdKycStart = 'poolIdKycStart'

export const stableCoinsTickers = ['USDC', 'USDT', 'DAI']
export const USD_DECIMALS = 6

export const revertLink = 'https://revert.finance/#/uniswap-position/arbitrum/'
